import React from 'react';
import {BooleanField, Labeled, NumberField, Show, SimpleShowLayout, Tab, TabbedShowLayout, TextField} from 'react-admin';

export const OrderShow = (props: any) => (
    <Show title="Dettagli Ordine" {...props}>
        <TabbedShowLayout>
            <Tab label="Informazioni Ordine">
                <Labeled label="ID Ordine">
                    <TextField source="id" />
                </Labeled>
                <Labeled label="Payment ID">
                    <TextField source="paymentId" />
                </Labeled>
                <Labeled label="Tipo di Pagamento">
                    <TextField source="paymentType" />
                </Labeled>
                <Labeled label="Quantità">
                    <NumberField source="quantity" />
                </Labeled>
                <Labeled label="Stato">
                    <TextField source="status" />
                </Labeled>
                <Labeled label="Ordine Annullato">
                    <BooleanField source="cancelOrder" />
                </Labeled>
            </Tab>
            <Tab label="Dettagli Finanziari">
                <Labeled label="Sub Totale">
                    <NumberField source="subTotal" options={{ style: 'currency', currency: 'EUR' }} />
                </Labeled>
                <Labeled label="Totale">
                    <NumberField source="total" options={{ style: 'currency', currency: 'EUR' }} />
                </Labeled>
                <Labeled label="Costo di Spedizione">
                    <NumberField source="shippingCharge" options={{ style: 'currency', currency: 'EUR' }} />
                </Labeled>
                <Labeled label="IVA">
                    <NumberField source="vat" options={{ style: 'currency', currency: 'EUR' }} />
                </Labeled>
                <Labeled label="Coupon">
                    <TextField source="coupon" />
                </Labeled>
                <Labeled label="Codice di Stato">
                    <NumberField source="statusCode" />
                </Labeled>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
